import { useMutation, useQuery } from "@tanstack/react-query";
import { get, post } from "../../api/client";
import { StudentResultPayload } from "../../Constants/Interfaces/payloadInterface/ResultsPayload.interface";
import queryClient from "../../config/queryClient";

export const Student_Result_Key = {
  STUDENT_RESULT_LISTS: "STUDENT_RESULT_LISTS",
};

export const useGetStudentListForResult = ({
  page = 1,
  resultId,
  onSuccess,
}: {
  page: number;
  resultId: number;
  onSuccess: (data: any) => unknown;
}) => {
  return useQuery(
    [Student_Result_Key.STUDENT_RESULT_LISTS, page, resultId],
    () => {
      if (!resultId) return;

      return get({
        url: `api/v1/results/students/${resultId}`,
        params: {
          page,
        },
      });
    },
    {
      onSuccess: (data: any) => {
        onSuccess(data);
      },
    }
  );
};

export const useSaveStudentResults = ({
  onSuccess,
  onError,
}: {
  onSuccess: () => unknown;
  onError: (err: Error) => unknown;
}) =>
  useMutation(
    (body: StudentResultPayload) => {
      return post({
        url: "api/v1/results/save/studenrResult",
        body,
      });
    },
    {
      onSuccess: () => {
        onSuccess();
        queryClient.invalidateQueries({
          queryKey: [Student_Result_Key.STUDENT_RESULT_LISTS],
        });
      },
      onError: (err: Error) => onError(err),
    }
  );

export const useDownloadStudentResult = ({
  onSuccess,
  onError,
}: {
  onSuccess?: (data: any) => unknown;
  onError: (error: Error) => unknown;
}) =>
  useMutation(
    ({ resultId, studentId }: { resultId: number; studentId: number }) => {
      return post({
        url: "api/v1/results/generate-result",
        params: {
          resultId,
          studentId,
        },
      });
    },
    {
      onSuccess,
      onError: (error: Error) => onError(error),
    }
  );
